// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"a28d5995","650":"aec45430"}[chunkId] + ".chunk.js";
};